import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyflowNoBoatsFoundComponent } from './buyflow-no-boats-found.component';
import { BuyflowNoBoatsFoundRoutingModule } from './buyflow-no-boats-found-routing.module';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';

@NgModule({
  declarations: [BuyflowNoBoatsFoundComponent],
  imports: [CommonModule, BuyflowNoBoatsFoundRoutingModule, AppMaterialModule],
  exports: [BuyflowNoBoatsFoundComponent],
})
export class BuyflowNoBoatsFoundModule {}
